import { ManagementComponent } from '../management.component';
import { Component, OnInit, Inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {Router} from "@angular/router";
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'app-appsettings',
  templateUrl: './appsettings.component.html',
  styleUrls: ['./appsettings.component.css']
})
export class AppsettingsComponent implements OnInit {

  constructor(public parent: ManagementComponent, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet) { 
    translate.addLangs(['en', 'ro']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro/) ? browserLang : 'en');

    // Debounce search.
    this.searchTermUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(value => {
        this.GetUsersFiltered(value);
      });
  }

  ngOnInit(): void {

  }

  SearchTerm:string;
  users:any[];
  SelectedUser:any;
  roleID:number;
  loadingUser:boolean;
  searchTermUpdate = new Subject<string>();

  SelectedRightType:any;
  SelectedOrderType:any;

  RightDetails:any;

  GetUsersFiltered(searchTerm:string){
    
   if(searchTerm != null){
    if(searchTerm.length > 2){
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        SearchTerm:searchTerm,
        RoleID:this.roleID
      };
  
      this.parent.loading = true;
  
      this.service.GetUsersFiltered(request).subscribe(response => {
     
        if(response["Status"] != 1){
        
        }
        else if(response["Status"] == 1){
          this.users = response["Users"];
        }
     
        this.parent.loading = false;
      });
    }
   }
  }

  GetUser(user:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      id:user.Id,
      WithDetails:true,
    };

    this.loadingUser = true;

    this.service.GetUser(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.SelectedUser = response["User"];
        this.users = [];
        this.SearchTerm = this.SelectedUser.UIName;
        this.SelectedRightType = {};
        this.RightDetails = null;
      }
   
      this.loadingUser = false;
    });
  }

  SelectRightType(t:any){
    if(t.ID == 1){
      this.RightDetails = this.SelectedUser.UserManagementInfo?.ManagementRights?.AutomatedTasksRights;
    }
    else if(t.ID == 2){
      this.RightDetails = this.SelectedUser.UserManagementInfo?.ManagementRights?.InternalTasksRights;
    }
    else if(t.ID == 3){
      this.RightDetails = this.SelectedUser.UserManagementInfo?.ManagementRights?.LogisticRights;
    }
    else if(t.ID == 4){
      this.RightDetails = this.SelectedUser.UserManagementInfo?.ManagementRights?.OCRights;
    }
    else if(t.ID == 5){
      this.RightDetails = this.SelectedUser.UserManagementInfo?.ManagementRights?.PORights;
    }
    else if(t.ID == 6){
      this.RightDetails = this.SelectedUser.UserManagementInfo?.ManagementRights?.QuotationRights;
    }
    else if(t.ID == 7){
      this.RightDetails = this.SelectedUser.UserManagementInfo?.ManagementRights?.PartnersRights;
    }
    else if(t.ID == 8){
      this.RightDetails = this.SelectedUser.UserManagementInfo?.ManagementRights?.ProductsRights;
    }
  }

  OverwriteCurrentSelectedRights(t:any){
    if(t.ID == 1){
      this.SelectedUser.UserManagementInfo.ManagementRights.AutomatedTasksRights = this.RightDetails;
    }
    else if(t.ID == 2){
      this.SelectedUser.UserManagementInfo.ManagementRights.InternalTasksRights = this.RightDetails;
    }
    else if(t.ID == 3){
      this.SelectedUser.UserManagementInfo.ManagementRights.LogisticRights = this.RightDetails;
    }
    else if(t.ID == 4){
      this.SelectedUser.UserManagementInfo.ManagementRights.OCRights = this.RightDetails;
    }
    else if(t.ID == 5){
      this.SelectedUser.UserManagementInfo.ManagementRights.PORights = this.RightDetails;
    }
    else if(t.ID == 6){
      this.SelectedUser.UserManagementInfo.ManagementRights.QuotationRights = this.RightDetails;
    }
    else if(t.ID == 7){
      this.SelectedUser.UserManagementInfo.ManagementRights.PartnersRights = this.RightDetails;
    }
    else if(t.ID == 8){
      this.SelectedUser.UserManagementInfo.ManagementRights.ProductsRights = this.RightDetails;
    }
  }

  AddUpdateUserManagementInfo(user:any){

    this.OverwriteCurrentSelectedRights(this.RightDetails.GeneralRightType);

    var request = {
      User:user,
      Language:this.parent.getLanguage(),
      IsAutoAdd:true,
    };

    this.loadingUser = true;

    this.service.AddUpdateUserManagementInfo(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        this.SelectedUser.UserManagementInfo = response["UserManagementInfo"];
      }
   
      this.loadingUser = false;
    });
  }

}
